import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RotorTypeListState, RotorTypeListStoreName } from './rotor-type-list.reducers';

/**
 * Selects rotor type list store.
 */
const rotorTypeListState = createFeatureSelector<RotorTypeListState>(RotorTypeListStoreName);

/**
 * Selects rotor type
 */
export const selectRotorType = createSelector(
  rotorTypeListState,
  (state: RotorTypeListState) => state.rotorType
);

/**
 * Selects available type data
 */
export const selectTypeData = createSelector(
  rotorTypeListState,
  (state: RotorTypeListState) => state.typeData
);

/**
 * Selects available type data for right panel
 */
export const selectRightPanelTypeData = createSelector(
  rotorTypeListState,
  (state: RotorTypeListState) => state.rightPanelTypeData
);

/**
 * Selects number of rotor types
 */
export const noOfRotorTypes = createSelector(
  rotorTypeListState,
  (state: RotorTypeListState) => (state.typeData ? state.typeData.totalRecords : 0)
);

export const selectGridConfig = createSelector(
  rotorTypeListState,
  (state: RotorTypeListState) => state.gridConfig
);
